import LeftmenuConst from '../constants/leftmenu.constants';
import UserServices from '../../services/user.services';

const userService = new UserServices();

export const LoadLeftMenuData = (menuId, data, activeMenuId = false) => ({
  type: LeftmenuConst.LOAD_MENU_DATA,
  menuId,
  data,
  activeMenuId,
});

export const UpdateKeepOpenStatus = keep_open => ({
  type: LeftmenuConst.UPDATE_KEEP_OPEN,
  keep_open,
});

export const UpdateCollapseMenu = (menuId, collapse_all) => ({
  type: LeftmenuConst.UPDATE_COLLAPSE_MENU,
  menuId,
  collapse_all,
});

export const UpdateCollapseSingleMenu = (menuId, id, collapse) => ({
  type: LeftmenuConst.UPDATE_COLLAPSE_SINGLE_MENU,
  menuId,
  id,
  collapse,
});

export const ActiveLeftMenuId = (menuId, highLightObjectId = '', highLightObjectType = '', reloadMenu = false) => async(dispatch, getState) => {
  console.log('state', getState());
  console.log('menuId', menuId);
  console.log('highLightObjectId', highLightObjectId);
  const stateVal = getState();
  if (typeof stateVal[menuId] !== 'undefined') {
    const selectedMenu = stateVal[menuId];
    if (window.isVnextPage() && menuId !== 'hr') {
      dispatch({
        type: LeftmenuConst.ACTIVE_LEFTMENU,
        menuId: '',
        highLightObjectId,
        highLightObjectType,
      });  

    } else {
      const { menus } = selectedMenu || {};
      if (!Object.keys(selectedMenu).length || !menus || reloadMenu) {
        const payload = { type: menuId };
          if (reloadMenu) {
            if (highLightObjectId) {
              payload.id = highLightObjectId;
            }
            if (highLightObjectType) {
              payload.objType = highLightObjectType;
            }
          }
        userService.getLeftMenuData(payload)
          .then((response) => {
            const { data } = response.data;
            dispatch({
              type: LeftmenuConst.LOAD_MENU_DATA,
              menuId,
              data,
              activeMenuId: !reloadMenu ? menuId : stateVal.activeMenuId,
            })
          });
      } else {
        dispatch({
          type: LeftmenuConst.ACTIVE_LEFTMENU,
          menuId,
          highLightObjectId,
          highLightObjectType,
        });
      }
    }
  } else {
    dispatch({
      type: LeftmenuConst.ACTIVE_LEFTMENU,
      menuId,
      highLightObjectId,
      highLightObjectType,
    });
  }

  // a11y: Mark unused left menu div as aria-hidden when using self-contained side nav
  if (menuId === "er") {
    $(".leftMenuDiv").attr("aria-hidden", "true");
  } else {
    $(".leftMenuDiv").attr("aria-hidden", "false");
  }
};

export const LeftmenuSorting = (pageId, menuId, ids) => ({
  type: LeftmenuConst.LEFTMENU_SORTING,
  pageId,
  menuId,
  ids,
});

export const UpdateLeftMenuData = (pageId, objectId = '', objectType = '', data = {}) => ({
  type: LeftmenuConst.UPDATE_LEFTMENU_DATA,
  pageId,
  objectId,
  objectType,
  data,
});

export const DeleteLeftMenuData = (pageId, objectId = '', objectType = '', data = {}) => ({
  type: LeftmenuConst.DELETE_LEFTMENU_DATA,
  pageId,
  objectId,
  objectType,
  data,
});

export const PinLeftMenuData = (pageId, objectId = '', pinStatus = '', data = {}, objectType) => ({
  type: LeftmenuConst.PIN_LEFTMENU_DATA,
  pageId,
  objectId,
  pinStatus,
  data,
  objectType,
});

export const UpdateMyWorkCount = (pageId, countData = {}) => ({
  type: LeftmenuConst.UPDATE_MYWORK_COUNT,
  pageId,
  countData,
});

export const HighLightedLeftMenuObjectId = (pageId, objectId, objectType, additionalParams = '') => ({
  type: LeftmenuConst.HIGHLIGHT_LEFTMENU_OBJECTID,
  pageId,
  objectId,
  objectType,
  additionalParams,
});

export const UpdateKrsCount = (pageId, countData = {}) => ({
  type: LeftmenuConst.UPDATE_KRS_COUNT,
  pageId,
  countData,
});


export const sortingLeftMenu = (menuId, result) => async(dispatch, getState) => {
  const { type, ids,sourceIndex, destinationIndex } = result;
  const values = getState();
  console.log('result', result);
  if (typeof values[menuId] !== 'undefined') {
    const selectedMenu = values[menuId] || {};
    if (typeof selectedMenu.menus !== 'undefined' && Array.isArray(selectedMenu.menus)) {
      userService.userFavoritesSorting({
        pageType: menuId,
        type,
        ids,
      });
      selectedMenu.menus = selectedMenu.menus.map((m) => {
        if (m.id == type) {
          const newItems = [...m.menus];
          const draggedItem = newItems[sourceIndex];
          newItems.splice(sourceIndex, 1);
          newItems.splice(destinationIndex, 0, draggedItem);
          m.menus = newItems;
        }
        return m;
      });
      dispatch({
        type: LeftmenuConst.SORTING_MENU_ITEM,
        menuId,
        data: selectedMenu,
      });
      if (typeof leftMenuModel !== 'undefined') {
        leftMenuModel.updateTopmenuFavorites(menuId, selectedMenu.menus);
      }
    }
  }
}

export const updateLeftMenu = (params) =>async(dispatch, getState) =>{
  dispatch(getRecursiveLeftMenu(params));
}

var oft = 0;
export const getRecursiveLeftMenu = (params) => async(dispatch,getState)=>{
  oft = params.offset;
  const result = await userService.getWsLeftMenuData(params);
  
  const values = getState();
    params.offset = params.offset+(result.data.data ? Object.keys(result.data.data).length : 0);
    if(result.data.data && Object.keys(result.data.data).length){
      dispatch({
        type: LeftmenuConst.UPDATE_WS_LEFT_MENU,
        menuId:'board',
        data: result.data
      });
    }
  if((oft != params.offset || (result.data.data && Object.keys(result.data.data).length != 0)) && params.offset !=0 ){
    dispatch(getRecursiveLeftMenu(params));
  }
  
}
